import { render, staticRenderFns } from "./ProductBrand.vue?vue&type=template&id=32fa0843&"
import script from "./ProductBrand.vue?vue&type=script&lang=js&"
export * from "./ProductBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32fa0843')) {
      api.createRecord('32fa0843', component.options)
    } else {
      api.reload('32fa0843', component.options)
    }
    module.hot.accept("./ProductBrand.vue?vue&type=template&id=32fa0843&", function () {
      api.rerender('32fa0843', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ProductBrand.vue"
export default component.exports